import { render } from "./HomeProjectList.vue?vue&type=template&id=2150e7be"
import script from "./HomeProjectList.vue?vue&type=script&lang=js"
export * from "./HomeProjectList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__